export default __webpack_public_path__ + "static/media/logoM.c897e0ac.png";